import { CancelationRulesStateInterface } from '.';

function state(): CancelationRulesStateInterface {
  return {
    cancelationRules: [],
  };
}

export default state;
